module.exports = __webpack_public_path__ + "img/assurtrak.b6e7ea56.png";